import React, { useEffect, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
// import RemoveIcon from "@mui/icons-material/Remove";
// import { useDispatch } from "react-redux";
// import { useSnackbar } from "notistack";
import OPProjectAssignOpTaskPM from "./OPProjectAssignOpTaskPM";
import { useCurrencySymbol } from "../../../../../utils/currencyUtils";
import CommaConvert from "../../../../../utils/CommaConvert";

const OPProjectAssignOpHardwrePM = ({
    row,
    index,
    loggedEmp,
    showActionToAssign,
    setProjectTasksEntries,
    projectTasksEntries,
    projectDescriptionEntries,
    projectHardwareParts,
    handleWorkEntriesSubmit,
    setProjectDescriptionEntries,
    handleDescriptionEntriesSubmit,
    setProjectHardwareParts,
    matchedOldRowDesctiption,
    matchedOldRowWorkEntries,
    matchedRowHardwareEntries,
    setIsLoading,
    isLoading,
    showListState,
    setTripDuration,
    tripDurationInput,
    isViewOnly = false
}) => {
    //  const dispatch = useDispatch();
    //   const { enqueueSnackbar } = useSnackbar();

    const currency = useCurrencySymbol();
    const USAComma = CommaConvert();

    const matchedPerson = row?.Assignedperson?.find(
        (person) => person?.email === loggedEmp?.EmpEmail
    );

    const [, setHasChanges] = useState(false);
    const [hardwarePartsOp, setHardwarePartsOp] = useState([]);
    const handleTripDuration = (e) => {
        if (isViewOnly) return;
        const value = e.target.value;
        setTripDuration(value)
    }

    useEffect(() => {
        if (projectHardwareParts.length > 0) {
            setHardwarePartsOp(projectHardwareParts)
        } else {
            setHardwarePartsOp([
                {
                    assemblepartdescription: "",
                    partno: "",
                    quantity: "",
                    unitprice: "",
                    totalprice: "",
                }
            ])
        }
    }, [projectHardwareParts])

    const handleInputChange = (index, field, value) => {
        if (isViewOnly) return;
        setProjectTasksEntries((prevRows) => {
            const newRows = [...prevRows];

            // Validation
            let validatedValue = value;
            if (field === "hoursassigned") {
                validatedValue = value.replace(/[^0-9]/g, "");
            } else if (field === "task" || field === "notes") {
                validatedValue = value.replace(/[^a-zA-Z0-9 .,?'-]/g, "");
            }

            newRows[index] = {
                ...newRows[index],
                [field]: validatedValue,
            };

            // 🔑 Check if at least one row has some data filled
            const hasAnyValue = newRows.some(
                (row) =>
                    (row.task && row.task.trim() !== "") ||
                    (row.hoursassigned && row.hoursassigned !== "") ||
                    (row.notes && row.notes.trim() !== "")
            );

            setHasChanges(hasAnyValue);

            return newRows;
        });
    };

    // const handleAddTaskRow = () => {
    //   if (projectTasksEntries.length < 15) {
    //     setProjectTasksEntries((prev) => [
    //       ...prev,
    //       { task: "", hoursassigned: "", notes: "" },
    //     ]);
    //   }
    // };
    const handleAddTaskRow = () => {
        if (isViewOnly) return;
        if (projectTasksEntries?.length === 0) {
            // If state is empty, add default row
            const newRow = { task: "", hoursassigned: "", notes: "" };
            setProjectTasksEntries([newRow]);
        } else if (projectTasksEntries.length < 15) {
            // Otherwise, add a new row normally
            setProjectTasksEntries([
                ...projectTasksEntries,
                { task: "", hoursassigned: "", notes: "" },
            ]);
        } else {
            // Optional: show a snackbar or message
            // enqueueSnackbar("You can only add up to 15 rows.", { variant: "error" });
        }
    };

    // const handleRemoveTaskRow = (index) => {
    //   setProjectTasksEntries((prev) => prev.filter((_, i) => i !== index));
    // };

    //   const handleRemoveTaskRow = (index) => {
    //     setProjectTasksEntries((prev) => {
    //       const rowToRemove = prev[index];

    //       // If it's the last row AND empty, remove it
    //       if (
    //         prev.length === 1 &&
    //         rowToRemove.task === "" &&
    //         rowToRemove.hoursassigned === "" &&
    //         rowToRemove.notes === ""
    //       ) {
    //         return []; // remove the empty object
    //       }

    //       // Otherwise, remove normally
    //       return prev.filter((_, i) => i !== index);
    //     });
    //   };

    // Description Tasks

    const handleTripInputChange = (index, field, value) => {
        if (isViewOnly) return;
        const newRows = [...projectDescriptionEntries];
        newRows[index][field] = value;
        setProjectDescriptionEntries(newRows);
    };

    // const handleAddRow = () => {
    //   if (projectDescriptionEntries.length < 15) {
    //     setProjectDescriptionEntries([
    //       ...projectDescriptionEntries,
    //       { description: "", value: "", notes: "" },
    //     ]);
    //   }
    // };
    const handleAddRow = () => {
        if (isViewOnly) return;
        if (projectDescriptionEntries?.length === 0) {
            // If state is empty, add default row
            const newRow = { description: "", value: "", notes: "" };
            setProjectDescriptionEntries([newRow]);
        } else if (projectDescriptionEntries.length < 15) {
            // Otherwise, add a new row normally
            setProjectDescriptionEntries([
                ...projectDescriptionEntries,
                { description: "", value: "", notes: "" },
            ]);
        } else {

        }
    };


    //   const handleRemoveRow = (index) => {
    //     const updatedRows = projectDescriptionEntries?.filter(
    //       (_, i) => i !== index
    //     );
    //     setProjectDescriptionEntries(updatedRows);
    //   };

    const validateValue = (value) => {
        // Allow numbers and single decimal point with max 2 decimal places
        const cleaned = value.replace(/[^0-9.]/g, "");
        const parts = cleaned.split(".");
        if (parts.length > 1) {
            return `${parts[0]}.${parts[1].slice(0, 2)}`;
        }
        return cleaned;
    };

    const validateDescriptionOrNotes = (value) => {
        return value.replace(/[^a-zA-Z0-9 .,?'-]/g, "");
    };


    //   const handleHardwarePartSubmit = async (hardwarePartsOp) => {

    //     const cleanedHardwareParts = hardwarePartsOp
    //     .filter((entry) => 
    //     entry?.assemblepartdescription !== null &&
    //     entry?.assemblepartdescription !== undefined &&
    //     entry?.assemblepartdescription !== "" &&
    //     entry?.quantity !== null &&
    //     entry?.quantity !== undefined &&
    //     entry?.quantity !== ""
    //   )
    //     .map((entry) => ({
    //       _id: entry?._id || null,
    //       assemblepartdescription: entry.assemblepartdescription,
    //       partno: entry.partno,
    //       permonth: entry.permonth,
    //       quantity: entry.quantity,
    //       unitprice: entry.unitprice,
    //       totalprice: entry.totalprice,
    //       oldtaskid: entry.oldtaskid || null,
    //     }));

    //     const Payload = {
    //       projectid: row._id,
    //       tasktype: "self",
    //       tasks: cleanedHardwareParts,
    //     };

    //     setIsLoading(true);
    //     try {
    //       await dispatch(replaceHardwareProjectTrack(Payload));
    //       enqueueSnackbar("Hardware Parts Saved", {
    //         variant: "success",
    //       });
    //       dispatch(fetchAllProjects());
    //       dispatch(fetchHardwareProjectTracking());
    //       setIsLoading(false);
    //     } catch {
    //       enqueueSnackbar("Failed to save Hardware", {
    //         variant: "error",
    //       });
    //     } finally {
    //       setIsLoading(false);
    //     }
    //   };

    //   const handleHardwareDescriptionSubmit = async (projectDescriptionEntries) => {
    //     if (
    //       projectDescriptionEntries.length === 1 &&
    //       (projectDescriptionEntries[0]?.value === undefined ||
    //         projectDescriptionEntries[0]?.value === "")
    //     ) {
    //       return;
    //     }


    //     const cleanedDescriptionEntries = projectDescriptionEntries
    //     .filter(
    //       (entry) =>
    //         entry?.description !== null &&
    //       entry?.description !== undefined &&
    //       entry?.description !== "" &&
    //       entry?.value !== null &&
    //       entry?.value !== undefined &&
    //       entry?.value !== ""    )
    //     .map(
    //       (entry) => ({
    //         _id: entry?._id || null,
    //         description: entry.description,
    //         value: entry.value,
    //         notes: entry.notes,
    //         oldtaskid: entry.oldtaskid || null,
    //         tripduration: row?.TypeService?.toLowerCase()?.includes("installation")
    //           ? (Number(tripDurationInput) ?? entry.tripduration ?? null)
    //           : entry.tripduration ?? null,
    //       })
    //     );

    //     const Payload = {
    //       projectid: row?._id,
    //       tasktype: "self",
    //       entries: cleanedDescriptionEntries,
    //     };

    //     setIsLoading(true);
    //     try {
    //       await dispatch(saveUpdateDescriptionTask(Payload));
    //       enqueueSnackbar("Description Entries Saved", {
    //         variant: "success",
    //       });
    //       dispatch(fetchAllProjects());
    //       dispatch(fetchDescriptionTasksProjectTracking());
    //       setIsLoading(false);
    //     } catch {
    //       enqueueSnackbar("Failed to save Description", {
    //         variant: "error",
    //       });
    //       setIsLoading(false);
    //     } finally {
    //       setIsLoading(false);
    //     }
    //   };
    return (
        <div>
            {row?.TypeService?.toLowerCase().includes("hardware")
                // {row.TypeService === "Hardware"
                ? showListState === "tasktable" && (
                    <div className="w-full rounded-lg h-full justify-center mb-2">

                        <OPProjectAssignOpTaskPM row={row}
                            hardwarePartsOp={hardwarePartsOp}
                            setHardwarePartsOp={setHardwarePartsOp}
                            matchedPerson={matchedPerson}
                        />
                    </div>
                )
                : showListState === "tasktable" && (
                    <>
                        <div className="w-full max-h-[14rem] overflow-auto">
                            {/* Sticky headers */}
                            <div className="w-full sticky top-0 z-10">
                                <div className="head flex text-center bg-blue-500 text-white text-[11px]">
                                    <div className="w-[10%] border p-1">Sr. No</div>
                                    <div className="w-[40%] border p-1">Task</div>
                                    <div className="w-[20%] border p-1">Hrs</div>
                                    <div className="w-[30%] border p-1">Notes</div>
                                </div>
                                <div className="head flex text-center bg-white text-black text-[11px]">
                                    <div className="w-[10%] border p-1"></div>
                                    <div className="w-[40%] border p-1">Total</div>
                                    <div className="w-[20%] border p-1">
                                        {
                                            projectTasksEntries?.reduce((sum, item) => {
                                                return sum + Number(item.hoursassigned || 0);
                                            }, 0)
                                        }
                                    </div>
                                    <div className="w-[30%] border p-1">
                                        {/* {projectTasksEntries?.length} Tasks */}
                                    </div>
                                </div>
                            </div>

                            <div className="w-full ">
                                {projectTasksEntries.map((row, index) => {
                                    const matchedOldWorkEntry = matchedOldRowWorkEntries.find(
                                        (old) => old._id === row.oldtaskid
                                    );
                                    return (
                                        <React.Fragment key={index}>
                                            <div className="flex items-center  text-center w-full text-[11px]">
                                                <div className="w-full bg-white">
                                                    <div className="head flex">
                                                        <div className={`w-[10%] p-1 border border-gray-200 ${row.lastEditedFields?.includes("task")
                                                            ? "bg-gray-400 text-white border "
                                                            : "border border-gray-200 bg-white"
                                                            }`}>
                                                            {index + 1}
                                                        </div>
                                                        <div
                                                            className="w-[40%] border border-gray-200"
                                                            title={
                                                                matchedOldWorkEntry
                                                                    ? `Previous Name: ${matchedOldWorkEntry.task}`
                                                                    : ""
                                                            }
                                                        >
                                                            <input
                                                            readOnly={true}
                                                                type="text"
                                                                name="task"
                                                                value={row.task || ""}
                                                                onChange={(e) => {
                                                                    const validValue = e.target.value.replace(
                                                                        /[^a-zA-Z0-9 ]/g, // Note the added space in the character class
                                                                        ""
                                                                    );
                                                                    handleInputChange(index, "task", validValue);
                                                                }}
                                                                // className="outline-none border-none text-center w-full h-full"
                                                                className={`outline-none border-none text-center w-full h-full   p-1  ${row.lastEditedFields?.includes("task")
                                                                    ? "bg-gray-400 text-white border "
                                                                    : "border border-gray-200"
                                                                    }`}
                                                            />
                                                        </div>
                                                        <div
                                                            className="w-[20%] border border-gray-200"
                                                            title={
                                                                matchedOldWorkEntry
                                                                    ? `Previous Hrs: ${matchedOldWorkEntry.hoursassigned}`
                                                                    : ""
                                                            }
                                                        >
                                                            <input
                                                                readOnly={true}
                                                                type="text"
                                                                name="hoursassigned"
                                                                value={row.hoursassigned || ""}
                                                                onKeyDown={(e) => {
                                                                    if (["e", "E", "+", "-"].includes(e.key)) {
                                                                        e.preventDefault();
                                                                    }
                                                                }}
                                                                onChange={(e) => {
                                                                    const value = e.target.value.replace(
                                                                        /[^0-9]/g,
                                                                        ""
                                                                    );

                                                                    handleInputChange(
                                                                        index,
                                                                        "hoursassigned",
                                                                        value
                                                                    );
                                                                }}
                                                                className={`outline-none border-none text-center w-full h-full p-1  ${row.lastEditedFields?.includes(
                                                                    "hoursassigned"
                                                                )
                                                                    ? "bg-gray-400 text-white border "
                                                                    : "border border-gray-200 "
                                                                    }`}
                                                            // className="outline-none border-none text-center w-full h-full"
                                                            />
                                                        </div>

                                                        <div
                                                            className="w-[30%] border border-gray-200"
                                                            title={
                                                                matchedOldWorkEntry
                                                                    ? `Previous Notes: ${matchedOldWorkEntry.notes}`
                                                                    : ""
                                                            }
                                                        >
                                                            <input
                                                                readOnly={true}
                                                                type="text"
                                                                name="notes"
                                                                value={row.notes || ""}
                                                                onChange={(e) => {
                                                                    const validValue = e.target.value.replace(
                                                                        /[^a-zA-Z0-9]/g,
                                                                        ""
                                                                    );

                                                                    handleInputChange(index, "notes", validValue);
                                                                }}
                                                                className={`outline-none border-none text-center w-full h-full p-1 ${row.lastEditedFields?.includes("notes")
                                                                    ? "bg-gray-400 text-white border "
                                                                    : "border border-gray-200 "
                                                                    }`}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* {matchedPerson?.projecttracktaskStatus !== "submit" && (
                            <>
                              {matchedPerson?.operationaction === "accept" && (
                                <>
                                  {index === projectTasksEntries.length - 1 && (
                                    <div className="flex justify-between px-2 pt-1 pb-2">
                                      <button
                                        className="shadow-xl rounded-md p-1 bg-gray-100 hover:bg-gray-200"
                                        onClick={handleAddTaskRow}
                                        title="Add row"
                                      >
                                        <AddIcon fontSize="small" />
                                      </button>
                                      <button
                                        className="shadow-xl rounded-md p-1 bg-gray-100 hover:bg-gray-200"
                                        onClick={() => {
                                          handleRemoveTaskRow(index);
                                          dispatch(deleteTask([row?._id]))
                                        }}
                                        title="Remove row"
                                      >
                                        <RemoveIcon fontSize="small" />
                                      </button>
                                    </div>
                                  )}
                                </>
                              )}
                            </>
                          )}
     */}

                                        </React.Fragment>
                                    );
                                })}

                                {projectTasksEntries.length === 0 && (
                                    <div className="flex justify-start px-2 pt-1 ">
                                        <button
                                            className={`shadow-xl rounded-md p-1 ${isViewOnly ? "opacity-50 cursor-not-allowed" : ""}`}
                                            onClick={handleAddTaskRow}
                                            disabled={isViewOnly}
                                        >
                                            <AddIcon fontSize="small" />
                                        </button>
                                    </div>
                                )}
                            </div>
                        </div>
                    </>
                )}

            {showListState === "otherexpenses" && (
                <div className="w-full max-h-[14rem] overflow-auto pb-2">
                    <div className="w-full sticky top-0 z-10">
                        <div className="head flex text-center bg-blue-500 text-white text-[11px]">
                            <div className="w-[10%] border p-1">Sr. No</div>
                            <div className="w-[40%] border p-1">Description</div>
                            <div className="w-[20%] border p-1">Amount ({currency})</div>
                            <div className="w-[30%] border p-1">Notes</div>
                        </div>
                        <div className="head flex text-center bg-white text-black text-[11px]">
                            <div className="w-[10%] border p-1"></div>
                            <div className="w-[40%] border p-1">Total</div>
                            <div className="w-[20%] border p-1">
                                {
                                    USAComma(projectDescriptionEntries?.reduce((sum, item) => {
                                        return sum + Number(item.value || 0);
                                    }, 0))
                                }
                            </div>
                            <div className="w-[30%] border p-1">
                                {/* {projectDescriptionEntries?.length} Expenses */}
                            </div>
                        </div>
                        {row?.TypeService?.toLowerCase().includes("installation") && (
                            <div className="sticky top-[24px] flex text-center bg-[#1973eb] text-white text-[11px] z-10">
                                <div className="w-[10%] border p-1 flex justify-center items-center"></div>
                                <div className="w-[40%] border p-1 flex justify-center items-center">Trip Duration</div>
                                <div className="w-[20%] border p-1">
                                    <input
                                        readOnly={true}
                                        value={projectDescriptionEntries[0].tripduration || tripDurationInput}
                                        type="text"
                                        name="tripduration"
                                        placeholder="trip duration"
                                        onChange={handleTripDuration}
                                        className={`outline-none border-none text-center w-full h-full p-0.5 border border-white text-black rounded-md `}
                                    />
                                </div>
                                <div className="w-[30%] border p-1"></div>
                            </div>
                        )}
                    </div>
                    <div className="w-full">
                        {projectDescriptionEntries.map((row, index) => {
                            const matchedOldDescription = matchedOldRowDesctiption.find(
                                (old) => old._id === row.oldtaskid
                            );
                            return (
                                <React.Fragment key={index}>
                                    <div className="flex items-center text-center w-full text-[11px]">
                                        <div className="head flex w-full">
                                            <div className={`w-[10%] p-1  border border-gray-200 ${row.lastEditedFields?.includes("description")
                                                ? "bg-gray-400 text-white border "
                                                : "bg-white"

                                                } `}>
                                                {index + 1}
                                            </div>
                                            <div
                                                className="w-[40%] border border-gray-200"
                                                title={
                                                    matchedOldDescription
                                                        ? `Previous Name:${matchedOldDescription.description}`
                                                        : ""
                                                }
                                            >
                                                <input
                                                    readOnly={true}
                                                    type="text"
                                                    name="description"
                                                    value={row.description}
                                                    onChange={(e) =>
                                                        handleTripInputChange(
                                                            index,
                                                            "description",
                                                            validateDescriptionOrNotes(e.target.value)
                                                        )
                                                    }
                                                    className={`outline-none border-none text-center w-full h-full   p-1  ${row.lastEditedFields?.includes("description")
                                                        ? "bg-gray-400 text-white border "
                                                        : "bg-white"
                                                        }`}
                                                // className="outline-none border-none text-center w-full h-full"
                                                />
                                            </div>

                                            <div
                                                className="w-[20%] border border-gray-200"
                                                title={
                                                    matchedOldDescription
                                                        ? `Previous Value: ${matchedOldDescription.value}`
                                                        : ""
                                                }
                                            >
                                                <input
                                                    readOnly={true}
                                                    type="text"
                                                    name="value"
                                                    value={USAComma(row.value)}
                                                    onFocus={(e) => {
                                                        if (e.target.value === "0") e.target.select();
                                                    }}
                                                    onClick={(e) => {
                                                        if (e.target.value === "0") e.target.select();
                                                    }}
                                                    onChange={(e) =>
                                                        handleTripInputChange(
                                                            index,
                                                            "value",
                                                            validateValue(e.target.value)
                                                        )
                                                    }
                                                    onKeyDown={(e) => {
                                                        if (["e", "E", "+", "-"].includes(e.key)) {
                                                            e.preventDefault();
                                                        }
                                                    }}
                                                    className={`outline-none border-none text-center w-full h-full   p-1  ${row.lastEditedFields?.includes("value")
                                                        ? "bg-gray-400 text-white border "
                                                        : "bg-white"
                                                        }`}
                                                />

                                            </div>

                                            <div
                                                className="w-[30%] border border-gray-200"
                                                title={
                                                    matchedOldDescription
                                                        ? `Previous Name: ${matchedOldDescription.notes}`
                                                        : ""
                                                }
                                            >
                                                <input
                                                    readOnly={true}
                                                    type="text"
                                                    name="notes"
                                                    value={row.notes}
                                                    onChange={(e) =>
                                                        handleTripInputChange(
                                                            index,
                                                            "notes",
                                                            validateDescriptionOrNotes(e.target.value)
                                                        )
                                                    }
                                                    className={`outline-none border-none text-center w-full h-full   p-1  ${row.lastEditedFields?.includes("notes")
                                                        ? "bg-gray-400 text-white border "
                                                        : "bg-white"
                                                        }`}
                                                // className="outline-none border-none text-center w-full h-full"
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    {/* {
                        matchedPerson?.projecttracktaskStatus !== "submit" && (
                          <>
                            {matchedPerson?.operationaction === "accept" && (
                              <>
                                {index === projectDescriptionEntries.length - 1 && (
                                  <div className="flex justify-between px-2 pt-1">
                                    <button
                                      className="shadow-xl rounded-md p-1"
                                      onClick={handleAddRow}
                                      disabled={
                                        projectDescriptionEntries.length >= 15
                                      }
                                    >
                                      <AddIcon />
                                    </button>
                                    <button
                                      className="shadow-xl rounded-md p-1"
                                      onClick={() => {
                                        handleRemoveRow(index);
                                        dispatch(deleteDescriptionTask(row?._id))
                                      }}
                                    >
                                      <RemoveIcon />
                                    </button>
                                  </div>
                                )}
                              </>
                            )}
                          </>
                        )
                      } */}

                                </React.Fragment>
                            );
                        })}

                        {projectDescriptionEntries.length === 0 && (
                            <div className="flex justify-start px-2 pt-1 ">
                                <button
                                    className={`shadow-xl rounded-md p-1 ${isViewOnly ? "opacity-50 cursor-not-allowed" : ""}`}
                                    onClick={handleAddRow}
                                    disabled={isViewOnly}
                                >
                                    <AddIcon fontSize="small" />
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            )
            }

            {/* {
            row.TypeService !== "Hardware" && (
              <>
                {matchedPerson?.operationaction === "accept" && (
                  <div className=" flex justify-end mb-2">
                    {matchedPerson?.projecttracktaskStatus === "submit" ? (
                      <div className="mt-2 mr-2 py-1 px-2 inline-block text-orange-600 border rounded-md text-start bg-gray-100">
                        Project submitted & under review
                      </div>
                    ) : (
                      <button
                        onClick={() => {
                          handleDescriptionEntriesSubmit(row);
                          handleWorkEntriesSubmit();
                        }}
                        className="mt-2 px-4 py-2 bg-blue-500 text-white rounded-md "
                      >
                        Submit
                      </button>
                    )}
                  </div>
                )}
              </>
            )
          } */}

            {/* {
            row?.TypeService?.toLowerCase().includes("hardware") ? (
              // {row.TypeService === "Hardware" ? (
              <div className="flex justify-end mb-2">
                {
                  // row.Assignedperson?.every(
                  //   (person) => person.projecttracktaskStatus === "submit" )
                  matchedPerson?.projecttracktaskStatus === "submit" ? (
                    <div className="py-1 px-2 mr-2 inline-block text-orange-600 border rounded-md text-start bg-gray-100">
                      Project submitted & under review
                    </div>
                  ) : (
                    matchedPerson?.operationaction === "accept" && (
                      <button
                        className="px-2 py-1 rounded-md text-white bg-blue-500 hover:bg-blue-800"
                        onClick={() => {
                          handleHardwareDescriptionSubmit(projectDescriptionEntries);
                          handleHardwarePartSubmit(hardwarePartsOp);
                        }}
                      >
                        Submit
                      </button>
                    )
                  )
                }
              </div>
            ) : (
              <></>
            )
          } */}
        </div >
    )
}

export default OPProjectAssignOpHardwrePM